import React, { useState } from "react";
import ImageUploader from "react-images-upload";
// import Button from "components/Shared/CustomButtons/Button";
import { useTheme } from "@mui/styles";

const ImageUpload = ({ image, setImage, error, setError }) => {
  const theme = useTheme();
  // const [singlePicture, setPicture] = useState({});
  const onDrop = (file, picture) => {
    if (file.length === 0 && picture.length === 0) {
      setError("Please choose an image");
    } else {
      setError(null);
    }
    setImage({ data_url: picture[0], file: file[0] });
  };
  return (
    <div>
      {error && <span style={{ color: "red" }}>{error}</span>}
      <ImageUploader
        fileContainerStyle={{
          backgroundColor: theme.palette.background.secondary,
          color: theme.palette.text.primary,
        }}
        singleImage={true}
        withPreview={true}
        labelStyles={
          error
            ? { color: "red", textAlign: "center" }
            : { textAlign: "center" }
        }
        defaultImages={image.data_url ? [image.data_url] : []}
        onChange={onDrop}
        buttonText="Choose image"
        buttonStyles={{
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.text.primary,
        }}
        label="Max file size: 1MB, accepted: jpg/png/jpeg/webp"
        imgExtension={[".jpg", ".png", ".jpeg", ".webp"]}
        maxFileSize={1048576}
      />
      {/* <ImageUploading value={images} onChange={setImages} dataURLKey="data_url">
        {({ imageList, onImageUpload, onImageRemove, dragProps }) => (
          <div>
            {image === null ? (
              <Button color="primary" onClick={onImageUpload} {...dragProps}>
                Click or Drop here
              </Button>
            ) : (
              <div>
                <div>
                  <Button color="danger" onClick={() => onImageRemove(0)}>
                    Remove
                  </Button>
                </div>
                <div>
                  <img src={imageList[0].data_url} alt="" width="100" />
                </div>
              </div>
            )}
          </div>
        )}
      </ImageUploading> */}
    </div>
  );
};

export default ImageUpload;
